import { render, staticRenderFns } from "./yrityslainahakemus.vue?vue&type=template&id=36720318&"
import script from "./yrityslainahakemus.vue?vue&type=script&lang=js&"
export * from "./yrityslainahakemus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports